/**
 * Client axios de la SPA SOC. Depuis #17-A (2026-07-06), le socle est
 * mutualisé dans `@ward3/frontend-shared/api` — cette app instancie
 * simplement le factory avec `withScopeOverrides: true` (headers
 * X-Mssp-Scope / X-Tenant-Scope + setters correspondants).
 *
 * L'admin SPA (`frontend-admin/`) instancie le même factory sans
 * scope overrides — pas de drift possible sur l'axios setup, le silent
 * refresh, ou l'event `anm:auth-expired`.
 */

import { createApiClient } from "@ward3/frontend-shared/api";

const client = createApiClient({ withScopeOverrides: true });

/** @type {import("axios").AxiosInstance} */
export const api = client.api;
export const setAccessToken = client.setAccessToken;
export const getAccessToken = client.getAccessToken;
export const setMsspScopeOverride = client.setMsspScopeOverride;
export const setTenantScopeOverride = client.setTenantScopeOverride;
